// extracted by mini-css-extract-plugin
module.exports = {"header":"items_list_header__2hYjr","item":"items_list_item__2KlM7"};